export default __webpack_public_path__ + "static/media/IconAlert.8efb3252.svg";